/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DateRangeActivated,
  DateRangeActivatedOptional,
  DateRangeActivatedMetaI,
  DateRangeActivatedTrackedI,
} from "./date-range-activated";
import {
  DateRangeActivatedTracked,
  DateRangeActivatedMeta,
} from "./date-range-activated";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";

/**
 *
 * @export
 * @interface PaymentSourceBase
 */
export interface PaymentSourceBaseOptional extends DateRangeActivatedOptional {
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  endActive?: Date;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentSourceBase
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  stripePaymentSource?: string;
}

export interface PaymentSourceBase
  extends PaymentSourceBaseOptional, DateRangeActivated {
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  endActive?: Date;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentSourceBase
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  stripePaymentSource?: string;
}

export interface PaymentSourceBaseTrackedI extends DateRangeActivatedOptional {
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentSourceBase
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceBase
   */
  stripePaymentSource?: string;
  stripePaymentSourceIsSet: boolean;
}

transformDatesMap.set("PaymentSourceBase", function (model: PaymentSourceBase) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
});

export type PaymentSourceBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  stripePaymentSource: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PaymentSourceBaseMeta: PaymentSourceBaseMetaI =
  {} as PaymentSourceBaseMetaI;
PaymentSourceBaseMeta = typeMeta("PaymentSourceBase", {
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  paymentType: propertyMeta(
    "paymentType",
    false,
    false,
    false,
    PaymentTypeMeta,
  ),
  stripePaymentSource: propertyMeta(
    "stripePaymentSource",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PaymentSourceBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DateRangeActivatedMeta]);
  metaI.startActive.inheritedFrom = DateRangeActivatedMeta.startActive;
  metaI.endActive.inheritedFrom = DateRangeActivatedMeta.endActive;
});

export class PaymentSourceBaseTracked
  extends DateRangeActivatedTracked
  implements PaymentSourceBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  stripePaymentSource__I?: string = undefined;
  stripePaymentSourceIsSet: boolean = false;
  set stripePaymentSource(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentSource__I = v;
      this.stripePaymentSourceIsSet = true;
    } else {
      this.stripePaymentSource__I = v || undefined;
      this.stripePaymentSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripePaymentSource() {
    return this.stripePaymentSource__I;
  }
  constructor(config?: PaymentSourceBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PaymentSourceBaseOptional,
    options?: AssignOptions,
  ): PaymentSourceBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.stripePaymentSource &&
      this.stripePaymentSourceApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentSource = config.stripePaymentSource;
      if (optionsRequired.unassign) this.stripePaymentSourceIsSet = false;
      else this.stripePaymentSourceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PaymentSourceBaseTrackedI {
    const cloned = {} as PaymentSourceBaseTrackedI;
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.stripePaymentSourceIsSetDeep() &&
      this.stripePaymentSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentSourceIsSet = true;
      cloned.stripePaymentSource = this.stripePaymentSource;
    } else {
      //cloned.stripePaymentSourceIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PaymentSourceBaseTrackedI {
    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.stripePaymentSourceApplyFilter(filter))
      this.stripePaymentSourceIsSet = false;

    return this;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceBaseMeta.startActive,
      PaymentSourceBaseMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceBaseMeta.endActive,
      PaymentSourceBaseMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceBaseMeta.paymentType,
      PaymentSourceBaseMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  stripePaymentSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceBaseMeta.stripePaymentSource,
      PaymentSourceBaseMeta,
      this.stripePaymentSource,
      this,
    );
  }
  stripePaymentSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentSourceIsSet &&
      this.stripePaymentSourceApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.stripePaymentSourceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
